import PropTypes from "prop-types";
import React from "react";
import {
  Container,
  Row,
  Col,
} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

const statCards = [
  {
    label: "Total Leads",
    value: "—",
    icon: "bx bx-user-plus",
    color: "primary",
  },
  {
    label: "Active Clients",
    value: "—",
    icon: "bx bx-group",
    color: "success",
  },
  {
    label: "Open Tickets",
    value: "—",
    icon: "bx bx-support",
    color: "warning",
  },
  {
    label: "Listings",
    value: "—",
    icon: "bx bx-buildings",
    color: "info",
  },
];

const Dashboard = props => {
  //meta title
  document.title = "Dashboard | Skote - React Admin & Dashboard Template";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Dashboards")}
            breadcrumbItem={props.t("Dashboard")}
          />

          <div className="dash-welcome">
            <h4>{props.t("Welcome back")}</h4>
            <p>{props.t("Here's an overview of your workspace.")}</p>
          </div>

          <Row className="g-3 mb-1">
            {statCards.map((stat, idx) => (
              <Col xl={3} md={6} key={idx}>
                <div className="dash-stat-card">
                  <div
                    className={`dash-stat-icon bg-${stat.color} bg-opacity-10 text-${stat.color}`}
                  >
                    <i className={stat.icon} />
                  </div>
                  <div className="dash-stat-value">{stat.value}</div>
                  <div className="dash-stat-label">{props.t(stat.label)}</div>
                </div>
              </Col>
            ))}
          </Row>

          <Row className="g-3 mt-1">
            <Col lg={7}>
              <div className="dash-panel p-4">
                <h5 className="card-title mb-3">{props.t("Recent Activity")}</h5>
                <p className="text-muted mb-0">
                  {props.t("Activity from your leads, clients and team will show up here.")}
                </p>
              </div>
            </Col>
            <Col lg={5}>
              <div className="dash-panel p-4">
                <h5 className="card-title mb-3">{props.t("Quick Links")}</h5>
                <p className="text-muted mb-0">
                  {props.t("Jump back into Clients, Billings or Settings from the sidebar.")}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(Dashboard);
